function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSpin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 33.3 33.3"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M24.3 9.4c2 1.9 3.2 4.6 3.3 7.4s-1 5.7-3.1 7.7c-2 2-5 3-7.8 2.9s-5.5-1.3-7.4-3.3c-2-1.9-3.3-4.5-3.5-7.4-.3-2.9.8-5.9 3-8 2.1-2.1 5.2-3.1 8-2.8 2.9.3 5.5 1.6 7.5 3.5m0 0c-2-1.9-4.8-2.9-7.4-2.6-2.7.2-5.1 1.4-6.9 3.2s-3.1 4.1-3.3 6.8c-.3 2.6.7 5.5 2.7 7.4 2 2 4.7 3 7.4 2.8 2.7-.1 5.3-1.2 7.2-3.1 1.9-1.8 3.1-4.4 3.2-7.1s-.9-5.5-2.9-7.4",
  style: {
    fill: "currentColor"
  }
}));
export default SvgSpin;